import { render, staticRenderFns } from "./ConfirmCreateServiceModal.vue?vue&type=template&id=3012d41c&scoped=true&"
import script from "./ConfirmCreateServiceModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCreateServiceModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCreateServiceModal.vue?vue&type=style&index=0&id=3012d41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3012d41c",
  null
  
)

export default component.exports